export const CSS = {
  assistiveText: "assistive-text",
  calendarWrapper: "calendar-wrapper",
  calendarWrapperEnd: "calendar-wrapper--end",
  horizontalArrowContainer: "horizontal-arrow-container",
  inputBorderTopColorOne: "border-top-color-one",
  inputContainer: "input-container",
  inputNoBottomBorder: "no-bottom-border",
  inputWrapper: "input-wrapper",
  input: "input",
  menu: "menu-container",
  menuActive: "menu-container--active",
  toggleIcon: "toggle-icon",
  verticalArrowContainer: "vertical-arrow-container",
  chevronIcon: "chevron-icon",
};
